module.exports = __webpack_public_path__ + "static/media/career-image-two.827a3408.png";